var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { singleton } from "tsyringe";
import { localizePath } from "../locale";
let RestaurantHoursService = class RestaurantHoursService {
    async fetchHours(slug) {
        const response = await fetch("/api/v1" + localizePath(`/restaurants/${slug}/hours`));
        return (await response.json());
    }
};
RestaurantHoursService = __decorate([
    singleton()
], RestaurantHoursService);
export { RestaurantHoursService };
